import React, {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {SETTINGS_PATH} from 'constants/path'
import {getPathWithPrefix} from 'utils/helper'
import RuleForm from './RuleForm'

const RulesDetails = props => {
  const navigate = useNavigate()
  const {toggleCreate} = props
  const {id: ruleId} = useParams()

  useEffect(() => {
    window.history.pushState(null, '', window.location.href)
    window.onpopstate = () => {
      if (toggleCreate) {
        toggleCreate(false)
      } else {
        navigate(getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.WORKFLOWS))
      }
    }
    return () => (window.onpopstate = () => {})
  }, [])

  return <RuleForm editId={ruleId} toggleCreate={toggleCreate} />
}

export default RulesDetails
